<template>
    <div class="body">
        <el-button type="primary" @click="line = true">添加优惠券</el-button>
        <el-row>
            <el-col class="card" :span="7" v-for="(item,index) in list" :key="index" :offset="index > 0 ? 0 : 0">
                <el-card  class="cardEl">
                    <div class="coupon">
                            <div class="couponA">
                                <p class="price">￥{{item.denomination}}</p>
                                <!-- <p class="rule">满{{item.rule}}元可用</p> -->
                            </div>
                            <div class="couponB">
                                <span>可使用</span>
                                <p class="type">{{item.name}}</p>
                                <p class="time" style=" display :inline-block ;width: 100%;overflow: hidden;textOverflow: ellipsis;whiteSpace: nowrap" :title=item.rule>{{item.rule}}</p>
                                <el-button size="mini" type="primary" @click="deleteMember(item.id)">删除</el-button>
                                <!-- <hr class="hr"/>
                                <p class="info">详细信息</p> -->
                            </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
             <el-dialog title="添加优惠券"  :visible.sync="line"   width="60%"   :before-close="handleClose">
                <el-form ref="form" :model="form" class="form" label-width="80px">
                    <el-form-item label="券名称:">
                        <el-input v-model="form.name" placeholder="请输入内容"></el-input>
                    </el-form-item>

                    <el-form-item label="面额:">
                        <el-input v-model="form.denomination" placeholder="请输入内容"></el-input>
                    </el-form-item>

                    <el-form-item label="简介:">
                        <el-input v-model="form.rule"  placeholder="请输入内容"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="line = false">取 消</el-button>
                    <el-button type="primary" @click="addCard">确 定</el-button>
                </span>
            </el-dialog>
    </div>    
</template>

<script>
export default {
    data(){
        return{
            line:false,
            list:[
                {id:1,price:1000,rule:1500,type:'仅可酒店使用',time:'2020.08.22-2020.10.01',abso:'可使用'},
                {id:2,price:2000,rule:2300,type:'仅可跟团使用',time:'2020.08.22-2020.10.01',abso:'已过期'},
                {id:3,price:3000,rule:4000,type:'仅可民宿使用',time:'2020.08.22-2020.10.01',abso:'快到期'},
                {id:4,price:500,rule:900,type:'仅可商城使用',time:'2020.08.22-2020.10.01',abso:'可使用'},
                {id:5,price:800,rule:1200,type:'仅可机票使用',time:'2020.08.22-2020.10.01',abso:'可使用'},
            ],
            form:{
                denomination:'',
                name:'',
                rule:''
            }
        }
    },
    mounted(){
        this.listMember();
    },
    methods:{
        //列表
        listMember(){
            this.joker.member.memberList().then(res=>{
                console.log(res)
                this.list = res.content
            }).catch(res=>{
                console.log(res)
            })
        },
        //添加
        addCard(){
            this.joker.member.addMember(this.form).then(res=>{
                this.line = false;
                console.log(res)
                this.listMember();
            }).catch(res=>{
                
            })
        },
        //删除
        deleteMember(id){
            this.joker.member.deleteMenber(id).then(res=>{
                this.listMember();
            }).catch(res=>{
                
            })
        },
         //添加弹框
        handleClose(done) {
          this.$confirm('确认关闭？')
          .then(_ => {
            done();
            var form ={id:null,productName: '',teamType: '',departCityName: '',characteristic: '',duration:'',price:'',coverFile: ''}
            this.form = form
          })
          .catch(_ => {});
        },
    }
    
}
</script>

<style scoped>


.card{
    margin-left: 3%;
    margin-top: 1%;
}

.cardEl{
    padding-bottom: 5%;
}


.price{
    color: #FFFFFF;
    font-size: 30px;
    margin-top: 5%;
    line-height: 90px;
    
}
.rule{
    color: #FFFFFF;
    font-size: 15px;
}

.hr{
    width: 80%;
    text-align:center;
    margin-left: 10%;
    border:1px dashed #696969;
}

.type{
    margin-top: 1%;
    height: 40%;
    font-size: 20px;
    font-weight: 700;
}

.time{
    height: 30%;
    /* max-width: 10em;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis; */
}

.info{
    margin-top: 1%;
}

.coupon{
  clear: both;
  padding-top: 1%;
}

.couponA{
      width: 110px;
      height: 100px;
      background: linear-gradient(0.25turn, #00c6ff, #0072ff), radial-gradient(circle at 11px 4px, transparent 6px, #0072ff 6px) top left, radial-gradient(circle at 10px 56px, transparent 6px, #0072ff 6px) bottom left, linear-gradient(0.25turn, #0072ff, #0072ff);
      background-repeat: no-repeat;
      background-size: 100px 100px, 15px 100px, 15px 100px, 50px 50px;
      background-position: 0px 0px,100px -4px, 100px 26px;
      border-radius:10px;
      float: left;
}

.couponB{
    float: left;
    background-color:#FFFFFF;
    height: 100px;
    width: 300px;
    border-radius:10px;
    border:1px dashed #696969;
    position:relative;
    overflow: hidden;
}

.couponB span{
    position: absolute;
    bottom:0;
    display: block;
    font-size:12px;
    color:#fff;
    background: #36A8FF;
    width:110px;
    height: 20px;
    text-align: center;
    transform: rotate(45deg);
    top:18px;
    right:-26px;
}

</style>


// WEBPACK FOOTER //
// src/components/Member/CouponList.vue